import React from 'react';
import { ModuleBase, Stack, Text, Link } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';

const ICPInsight = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, title, link1, description },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="ICPInsight overflow-hidden py-10 lg:py-18">
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-10 lg:items-stretch lg:gap-8',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="color-from-bg flex w-full flex-grow flex-col justify-between lg:w-1/2">
          {title && <Text className="text-style-h2" dangerouslySetInnerHTML={{ __html: title }} />}
        </div>
        <div className="color-from-bg relative flex w-fit flex-col lg:w-1/2">
          {description && <Text className="text-style-h4 xl:w-4/5" dangerouslySetInnerHTML={{ __html: description }} />}
          {link1 && <Link animate className="btn primary v2 mt-10" link={link1} />}
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default ICPInsight;
